import CIMSTable from 'components/CIMSTable'
import { useNonUserEmailsTableContext } from '../../NonUserEmailsTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions.tsx'
import { useEditOptions } from './hooks/useEditOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions.tsx'

export const NonUserEmailsTable: React.FC = () => {
  const { records, refetch, fetching } = useNonUserEmailsTableContext()

  const columns = useColumns()
  const createOptions = useCreateOptions()
  const editOptions = useEditOptions()
  const removeOptions = useRemoveOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      records={records}
      columns={columns}
      loading={fetching}
      actions={{
        header: { create: createOptions, onReload: refetch },
        row: { edit: editOptions, remove: removeOptions },
      }}
    />
  )
}
